import { render, staticRenderFns } from "./PersonTaxableRebateRegNew.vue?vue&type=template&id=fca120cc"
import script from "./PersonTaxableRebateRegNew.vue?vue&type=script&lang=js"
export * from "./PersonTaxableRebateRegNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports